import PropositionPageLexique from 'locales/types/containers/propositionPage/propositionPage';

export const propositionPageLexique: PropositionPageLexique = {
    headTitle: 'Proposition - Kolsquare',
    back: `Back to my propositions`,
};

export default propositionPageLexique;
